// The audio of a call, played through hidden <audio> elements - one per stream that should be heard. The layers'
// own videos are always muted (the same person can be in a grid and a speaker layer at once, which would play
// them twice), so this is the only place a call's sound comes out. `shouldPlay(caller)` picks who is heard: the
// studio and guest pages hear everyone in the call, the broadcast only the owner and whoever is on stage. A
// session's own streams are never played back to it.
export function createCallAudio({ session, muted = false, shouldPlay = () => true }) {
	const streams = new Map(); // stream id -> { receiver, el }
	let isMuted = muted;

	const sync = callers => {
		const wanted = new Set();
		for(const c of callers) {
			if(c.callerId === session.ownCallerId || !shouldPlay(c)) continue;
			wanted.add(c.callerId);
			if(c.screenId) wanted.add(c.screenId);
		}
		for(const [ streamId, entry ] of streams) {
			if(wanted.has(streamId)) continue;
			entry.receiver.close();
			entry.el.remove();
			streams.delete(streamId);
		}
		for(const streamId of wanted) {
			if(streams.has(streamId)) continue;
			const el = document.createElement('audio');
			el.autoplay = true;
			el.muted = isMuted;
			document.body.appendChild(el);
			const receiver = session.openReceiver(streamId);
			receiver.onStream(stream => {
				el.srcObject = stream;
				if(stream) el.play().catch(e => console.error('remote audio play error', e));
			});
			streams.set(streamId, { receiver, el });
		}
	};
	const unsubscribe = session.onCallers(sync);

	return {
		setMuted(value) {
			isMuted = value;
			for(const { el } of streams.values()) el.muted = value;
		},
		destroy() {
			unsubscribe();
			for(const { receiver, el } of streams.values()) {
				receiver.close();
				el.remove();
			}
			streams.clear();
		},
	};
}
